import { render, staticRenderFns } from "./RightPanelContainer.vue?vue&type=template&id=4c85c0c3&scoped=true&"
import script from "./RightPanelContainer.vue?vue&type=script&lang=js&"
export * from "./RightPanelContainer.vue?vue&type=script&lang=js&"
import style0 from "./RightPanelContainer.vue?vue&type=style&index=0&id=4c85c0c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c85c0c3",
  null
  
)

export default component.exports